/**
 * Review Slider Component
 * Handles the slider functionality for customer reviews
 */

class ReviewSlider {
  constructor(element) {
    this.slider = element;
    this.track = this.slider.querySelector('.review-slider__track');
    this.slides = Array.from(this.slider.querySelectorAll('.review-slider__slide'));
    this.prevButton = this.slider.querySelector('.review-slider__arrow--prev');
    this.nextButton = this.slider.querySelector('.review-slider__arrow--next');
    this.dots = Array.from(this.slider.querySelectorAll('.review-slider__dot'));
    
    this.currentIndex = 0;
    this.autoplayInterval = null;
    
    this.autoplay = this.slider.dataset.autoplay === 'true';
    this.autoplaySpeed = parseInt(this.slider.dataset.autoplaySpeed) * 1000 || 5000;
    
    this.init();
  }
  
  init() {
    if (this.slides.length <= 1) return;
    
    // Set up navigation
    if (this.prevButton && this.nextButton) {
      this.prevButton.addEventListener('click', () => this.prev());
      this.nextButton.addEventListener('click', () => this.next());
    }
    
    // Set up dots
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.goToSlide(index));
    });
    
    // Set up touch/swipe
    this.setupTouch();
    
    // Set up autoplay
    if (this.autoplay) {
      this.startAutoplay();
      
      // Pause on hover
      this.slider.addEventListener('mouseenter', () => this.stopAutoplay());
      this.slider.addEventListener('mouseleave', () => this.startAutoplay());
    }
    
    // Initial position
    this.updateSlider();
  }
  
  setupTouch() {
    let startX = 0;
    let currentX = 0;
    let isDragging = false;
    
    this.track.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      isDragging = true;
      this.stopAutoplay();
    });
    
    this.track.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      currentX = e.touches[0].clientX;
    });
    
    this.track.addEventListener('touchend', () => {
      if (!isDragging) return;
      isDragging = false;
      
      const diff = startX - currentX;
      
      if (Math.abs(diff) > 50) {
        if (diff > 0) {
          this.next();
        } else {
          this.prev();
        }
      }
      
      if (this.autoplay) {
        this.startAutoplay();
      }
    });
  }
  
  prev() {
    this.currentIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
    this.updateSlider();
  }
  
  next() {
    this.currentIndex = (this.currentIndex + 1) % this.slides.length;
    this.updateSlider();
  }
  
  goToSlide(index) {
    this.currentIndex = index;
    this.updateSlider();
    this.stopAutoplay();
    if (this.autoplay) {
      this.startAutoplay();
    }
  }
  
  updateSlider() {
    const slideWidth = this.slides[0].offsetWidth;
    const offset = -(this.currentIndex * slideWidth);
    
    this.track.style.transform = `translateX(${offset}px)`;
    
    // Update dots
    this.dots.forEach((dot, index) => {
      if (index === this.currentIndex) {
        dot.classList.add('review-slider__dot--active');
      } else {
        dot.classList.remove('review-slider__dot--active');
      }
    });
  }
  
  startAutoplay() {
    if (!this.autoplay) return;
    this.stopAutoplay();
    this.autoplayInterval = setInterval(() => {
      this.next();
    }, this.autoplaySpeed);
  }
  
  stopAutoplay() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = null;
    }
  }
}

// Initialize all review sliders on the page
document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.review-slider');
  sliders.forEach(slider => new ReviewSlider(slider));
});

// Re-initialize on Shopify section load (theme editor)
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const slider = event.target.querySelector('.review-slider');
    if (slider) {
      new ReviewSlider(slider);
    }
  });
}
